import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SessionStorage from '../../../api/session-storage';
import Requests from '../../../api/requests';
import classNames from 'classnames';
import InputField from '../../components/input-field/input-field';
import ButtonPrimary from '../../components/buttons/button-primary';
import Modal from '../../components/modal/modal';
import PopupOneButton from '../../components/popup/popup-one-button';
import { selectKey } from '../../../utilities/helper';
import {
  saveAdmin,
  receivedRoom,
  saveLoggedUser,
  receivedLogout,
} from '../../../store/actions/user-actions';
import './login.scss';
import _ from 'lodash';

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { saveAdmin, receivedRoom, saveLoggedUser, receivedLogout },
    dispatch,
  );
};

class Login extends React.Component {
  constructor() {
    super();

    this.state = {
      modalIsOpen: false,
      isButtonDisabled: true,
      emailValue: '',
      isEmailValid: true,
      launchValue: '',
      isLaunchValid: true,
      roomValue: '',
      isRoomValid: true,
      termsRejected: false,
      continueModalIsOpen: false,
      index: 0,
      modalIndex: 0,
      invalidModalIndex: 0,
      popupErrorMessage: '',
      popupTitle: '',
      popupButton: '',
      isKeyPressed: false,
      ip: null,
      errorCode: null,
      deviceid: '',
    };
  }

  componentDidMount() {
    window.addEventListener('keydown', this.keySelect);
    window.addEventListener('keyup', this.stopKeyPress);
    this.getIpAddress();
    const { saveLoggedUser } = this.props;
    SessionStorage.clearStorage();
    saveLoggedUser(false);
    const query = new URLSearchParams(this.props.location.search);
    const email = query.get('email');
    const launchcode = query.get('launchcode');
    const deviceid = query.get('deviceid');
    this.setState({
      emailValue: email ? email : '',
      launchValue: launchcode ? launchcode : '',
      roomValue:
        launchcode && this.props.isRemote ? `Remote-${launchcode}` : '',
      deviceid: deviceid ? deviceid : '',
    });
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.keySelect);
    window.removeEventListener('keyup', this.stopKeyPress);
  }

  componentDidUpdate(prevProps, prevState) {
    const keys = ['emailValue', 'launchValue', 'roomValue'];
    const hasInputFieldsChanged = keys.some(
      key => prevState[key] !== this.state[key],
    );

    if (
      hasInputFieldsChanged ||
      this.state.isEmailValid !== prevState.isEmailValid ||
      this.state.isRoomValid !== prevState.isRoomValid
    ) {
      const allInputFieldsHaveValues = keys.every(
        key => this.state[key].trim().length > 0,
      );

      this.setState({
        isButtonDisabled:
          !allInputFieldsHaveValues ||
          !this.state.isEmailValid ||
          !this.state.isRoomValid,
      });
    }
  }

  openModal = () => {
    window.removeEventListener('keydown', this.keySelect);
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
      modalIndex: 0,
    });
    window.addEventListener('keydown', this.keySelect);
  };

  onClickModalButton = () => {
    this.closeContinueModal();
    if (!this.state.deviceid) {
      switch (this.state.errorCode) {
        case 'TLE2000':
          this.setState({
            emailValue: '',
            launchValue: '',
            roomValue: '',
          });
          this.props.history.push('/remote/login');
          break;
        case 'TLE2010':
          this.setState({
            emailValue: '',
            launchValue: '',
            roomValue: '',
          });
          this.props.history.push('/center/login');
          break;
        default:
          break;
      }
    }
  };

  closeContinueModal = () => {
    this.setState({
      continueModalIsOpen: false,
      invalidModalIndex: 0,
      popupErrorMessage: '',
      popupTitle: '',
      popupButton: '',
    });
    window.addEventListener('keydown', this.keySelect);
  };

  onChangeEmail = event => {
    this.setState({ emailValue: event.target.value, isEmailValid: true });
  };

  onChangeLaunch = event => {
    this.setState({ launchValue: event.target.value }, () => {
      if (this.props.isRemote) {
        this.setState({ roomValue: `Remote-${this.state.launchValue}` });
      }
    });
  };

  onChangeRoom = event => {
    this.setState({ roomValue: event.target.value, isRoomValid: true });
  };

  onFocusEmail = () => {
    this.setState({ isEmailValid: true });
  };

  onFocusRoom = () => {
    this.setState({ isRoomValid: true });
  };

  onFocusLaunch = () => {
    this.setState({ isLaunchValid: true });
  };

  validateFields = () => {
    const regEmail = /\S+@\S+\.\S+/;
    // eslint-disable-next-line
    const regRoom = /([a-zA-Z0-9])+\-([a-zA-Z0-9])+/;
    const regLaunchCode = /[^a-zA-Z0-9]+/;
    const isEmailValid = regEmail.test(this.state.emailValue);
    const roomValidate = this.state.roomValue.match(regRoom);
    const isLaunchValid = !this.state.launchValue.match(regLaunchCode);
    const isRoomValid =
      roomValidate !== null && roomValidate[0] === this.state.roomValue;
    if (!isEmailValid || !isRoomValid || !isLaunchValid) {
      this.setState({
        isEmailValid: isEmailValid,
        isRoomValid: isRoomValid,
        isLaunchValid: isLaunchValid,
      });
    } else {
      this.signIn();
    }
  };

  getIpAddress = async () => {
    let response = await fetch('https://api.ipify.org?format=json');
    let json = await response.json();
    if (json && _.get(json, 'ip')) {
      this.setState({ ip: _.get(json, 'ip') });
    }
  };

  signIn = async () => {
    const user = {
      email: this.state.emailValue.trim(),
      launchCode: this.state.launchValue.trim(),
      roomCode: this.state.roomValue.trim(),
      ip_address: this.state.ip,
      device_id: this.state.deviceid,
    };
    const { ok, json: body, status } = await Requests.authorize(user);

    if (ok) {
      const { saveAdmin, receivedRoom, receivedLogout } = this.props;
      const admin = {
        reg_id: body.reg_id,
        admin_id: body.admin_id,
        ts_and_cs_ind: body.ts_and_cs_ind,
        token: body.token,
      };
      receivedLogout(false);
      SessionStorage.saveRoom(this.state.roomValue);
      receivedRoom(this.state.roomValue);
      saveAdmin(admin);
      this.props.history.push('/user-confirmation');
    } else {
      if (status === 400) {
        this.setState({
          continueModalIsOpen: true,
          popupErrorMessage: 'Please enter all the fields',
          popupTitle: 'Missing info',
          popupButton: 'Retry',
        });
        window.removeEventListener('keydown', this.keySelect);
      }
      if (status === 403) {
        this.setState({
          continueModalIsOpen: true,
          popupErrorMessage: body.error.message,
          popupTitle: 'Invalid info',
          popupButton: 'Retry',
        });
        window.removeEventListener('keydown', this.keySelect);
      }
      if (status === 451) {
        let code = body.error.code;
        let title = 'Invalid login';
        if (code === 'TLE2000' || code === 'TLE2010') {
          title = 'Invalid launch URL';
        }
        if (code === 'TLE0200') {
          title = 'Invalid launch date/time';
        }
        this.setState({
          continueModalIsOpen: true,
          popupErrorMessage: body.error.message,
          popupTitle: title,
          popupButton: 'OK',
          errorCode: body.error.code,
        });
        window.removeEventListener('keydown', this.keySelect);
      }
    }
    if (status === 500) {
      this.setState({
        continueModalIsOpen: true,
        popupErrorMessage: 'Error updating Test Launch information.',
        popupTitle: 'Error',
        popupButton: 'Try again',
      });
      window.removeEventListener('keydown', this.keySelect);
    }
  };

  setIndex = index => {
    this.setState({ index: index });
  };

  setModalIndex = index => {
    this.setState({ modalIndex: index });
  };

  setInvalidModalIndex = index => {
    this.setState({ invalidModalIndex: index });
  };

  keySelect = event => {
    const focusedElement = document.activeElement.id;

    if (
      event.key === 'Enter' &&
      !this.state.isButtonDisabled &&
      !this.state.continueModalIsOpen &&
      !this.state.isKeyPressed &&
      focusedElement !== 'button-secondary'
    ) {
      event.stopPropagation();
      this.setState({ isKeyPressed: true });
      this.validateFields();
    }
  };

  modalNavigation = event => {
    const ids = ['button-primary-modal', 'button-secondary-modal'];

    const focusedElement = document.activeElement.id;
    const arrows = ['ArrowDown', 'ArrowUp'];
    if (this.state.modalIndex <= ids.length - 1 && this.state.modalIndex >= 0) {
      selectKey(
        event,
        this.state.modalIndex,
        ids,
        focusedElement,
        this.setModalIndex,
        arrows,
      );
    }
  };

  invalidModalNavigation = event => {
    const ids = ['button-primary-modal', 'close-modal'];
    const focusedElement = document.activeElement.id;
    const arrows = ['ArrowDown', 'ArrowUp'];
    if (
      this.state.invalidModalIndex <= ids.length - 1 &&
      this.state.invalidModalIndex >= 0
    ) {
      selectKey(
        event,
        this.state.invalidModalIndex,
        ids,
        focusedElement,
        this.setInvalidModalIndex,
        arrows,
      );
    }
  };

  stopKeyPress = event => {
    if (event.key === 'Enter') {
      this.setState({ isKeyPressed: false });
    }
  };

  render() {
    const fieldsClass = classNames('login-input-fields', {
      'rejected-terms': this.state.termsRejected,
    });
    const index = this.state.isButtonDisabled && -1;

    return (
      <main className="login">
        <h1 aria-label="Welcome to A C T's Test Launch Portal.">
          Welcome to <span>ACT's Test Launch Portal.</span>
        </h1>
        <p>
          Please enter the credentials given to you to begin your
          assessment.{' '}
        </p>
        <div className={fieldsClass}>
          <InputField
            label="Email"
            message="Enter the email address shown on your admission ticket."
            errorMessage="Your email address is not valid."
            name="email"
            id="email"
            onChange={this.onChangeEmail}
            onFocus={this.onFocusEmail}
            isValid={this.state.isEmailValid}
            value={this.state.emailValue}
            autoFocus={true}
            charLimit={255}
          />
          <InputField
            label="Launch Code (Case-sensitive)"
            message="Enter the Launch Code exactly as it appears on your admission ticket."
            errorMessage="Your Launch Code is not valid."
            name="launchCode"
            id="launchCode"
            onChange={this.onChangeLaunch}
            onFocus={this.onFocusLaunch}
            isValid={this.state.isLaunchValid}
            value={this.state.launchValue}
            charLimit={255}
          />
          <InputField
            label="Room Code"
            message="The room proctor will provide your Room Code."
            errorMessage="The Room Code is not valid."
            name="roomCode"
            id="roomCode"
            onChange={this.onChangeRoom}
            onFocus={this.onFocusRoom}
            isValid={this.state.isRoomValid}
            charLimit={255}
            value={this.state.roomValue}
            isDisabled={this.props.isRemote}
          />
        </div>
        <div className="buttons-container one-button">
          <ButtonPrimary
            buttonText="Continue"
            isDisabled={this.state.isButtonDisabled}
            onClick={this.validateFields}
            hasArrow={true}
            tabIndex={index.toString()}
          />
        </div>
        <Modal
          isOpen={this.state.continueModalIsOpen}
          closeModal={this.closeContinueModal}
          className={'modal-content one-button'}
          ariaProps={{
            modal: true,
          }}
          child={
            <PopupOneButton
              title={this.state.popupTitle}
              description={this.state.popupErrorMessage}
              buttonText={this.state.popupButton}
              padding="0 35px"
              onClick={this.onClickModalButton}
              closeModal={this.closeContinueModal}
              onKeyUp={this.invalidModalNavigation}
              isKeyPressed={this.state.isKeyPressed}
            />
          }
        />
      </main>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
